// extracted by mini-css-extract-plugin
module.exports = {"container":"virtualAssistantFormStepper_container__3hWsM","content":"virtualAssistantFormStepper_content__1pXWA","btn":"virtualAssistantFormStepper_btn__2R1G4","btnPrimary":"virtualAssistantFormStepper_btnPrimary__vP8TI","btnOutlined":"virtualAssistantFormStepper_btnOutlined__1OG_q"};
    if(module.hot) {
      // 1744882531334
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  